import { getMethod, postMethod, putMethod } from "../../api-service/api-service";
import { addCategory, editCategory, setCategories } from "./categorySlice";

export const fetchAllCategories = () => async (dispatch) => {
    try {
        const response = await getMethod("/category/");
        if (response.success === true) {
            dispatch(setCategories(response?.categories))
        }
        return response;
    } catch (error) {
        console.log("Error: ", error);
    }
}

export const addCategoryAction = (data) => async (dispatch) => {
    try {
        const response = await postMethod('/category', data);
        if (response.success === true) {
            dispatch(addCategory(response?.category))
        }
        return response
    } catch (error) {
        console.log("Error: ", error);
    }
}

export const editCategoryAction = (id, data) => async (dispatch) => {
    try {
        const response = await putMethod(`/category/${id}`, data);
        if (response.success === true) {
            dispatch(editCategory(response?.category));
        }
        return response;
    } catch (error) {
        console.log("Error: ", error);
    }
}